/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from "styled-components";

export const LinearGrad = styled.div`
    height:20px;
    background-image:linear-gradient(to right,white,#1C2141);
    width:calc(100% - 230px);
    margin-top:97px;
    margin-right:30px;
`;

export const Image = styled.img`
    width:150px;
    height:120px;
`;

export const Flexdiv = styled.div`
    display:flex;
    padding-bottom:2rem;
    position:sticky;
    top:100vh;
`;